import type { Fields } from '../components/FormFields/FormFields'

export const ForgotPasswordEmailField = [
  {
    autoComplete: 'email',
    field: 'email',
    label: 'Your email address',
    maxlength: '64',
    validation: {
      required: true,
      type: 'email',
      pattern:
        // eslint-disable-next-line max-len
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    },
    validationMessage: 'Please enter a valid email address.',
    showRequiredText: false,
    calledFrom: 'forgotPassword',
  },
]

export const Links = {
  forgotPassword: '/forgot-password',
  helpCenter: '/help/faqs-ar5va9s6hi1c',
  join: 'https://join.which.co.uk/',
  returnUrl: '/login?return_url=',
}

export const LoginPageBannerText = {
  generic: {
    authErrorText:
      "Sorry, we don't recognise that combination of email address/username and password.",
    authErrorContentText: `Please try again, or use the <a href="${Links.forgotPassword}" data-which-id="login error link">forgotten password</a> link to reset your password. For further help visit our <a href="${Links.helpCenter}" data-which-id="login error link">help centre</a>.`,
    Success: 'Success - you’ve reset your password. <strong>Please use it to login.</strong>',
  },
  userIdentifier: {
    authErrorText: "Sorry, we don't recognise that email address or username.",
    authErrorContentText: `Please try again. For further help visit our <a href="${Links.helpCenter}" data-which-id="login error link">help centre</a>.`,
    Success: 'Success - you’ve reset your password. <strong>Please use it to login.</strong>',
  },
  password: {
    authErrorText:
      "Sorry, we don't recognise that combination of email address/username and password.",
    authErrorContentText: `Please make sure you have typed your email address/username and password correctly and try again. For further help visit our <a href="${Links.helpCenter}" data-which-id="login error link">help centre</a>.`,
    Success: 'Success - you’ve reset your password. <strong>Please use it to login.</strong>',
  },
}

export const RegistrationFields: Fields[] = [
  {
    autoComplete: 'given-name',
    field: 'firstName',
    label: 'First name',
    validation: { required: true, minLength: 2, maxLength: 16 },
    validationMessage: 'Enter your first name',
    showRequiredText: true,
    calledFrom: 'registration',
  },
  {
    autoComplete: 'family-name',
    field: 'lastName',
    label: 'Last name',
    validation: { required: true, minLength: 2, maxLength: 32 },
    validationMessage: 'Enter your last name',
    showRequiredText: true,
    calledFrom: 'registration',
  },
  {
    autoComplete: 'email',
    field: 'email',
    fieldInfo: 'We will communicate about your membership via email',
    label: 'Email address',
    inputType: 'email',
    validation: {
      required: true,
      type: 'email',
      pattern:
        /^(?:[a-z0-9!#$%&'*+\x2f=?^_`\x7b-\x7d~\x2d]+(?:\.[a-z0-9!#$%&'*+\x2f=?^_`\x7b-\x7d~\x2d]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9\x2d]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9\x2d]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9\x2d]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/,
    },
    validationMessage: 'Enter a valid email address',
    showRequiredText: true,
    calledFrom: 'registration',
  },
]

export const ResetPasswordPageBannerText = {
  linkExpiredErrorText: 'The link to reset your password is either malformed or has expired',
  linkExpiredContentText: 'Please request a new link below.',
}

export const UsernameField = [
  {
    autoComplete: 'username',
    field: 'username',
    label: 'Email or username',
    maxlength: '64',
    validation: { required: true },
    validationMessage: 'Please enter your email address or username.',
    showRequiredText: false,
    calledFrom: 'login',
    trim: true,
  },
]
